import useEnviornmentRequests from './enviornment.js';

function useDistanceRequests () {
  const { getEnviornment } = useEnviornmentRequests();
  let url = getEnviornment();
  
  const returnObject = (status, message) => {
    return {
      status: status,
      message: message
    }
  };

  const getTimeDistances = async (events, bufferTime, accessToken) => {
    try {
      const bodyToSend = {
        events: events,
        bufferTime: bufferTime
      };
      
      const options = {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}`},
        body: JSON.stringify(bodyToSend)
      };

      const response = await fetch(`${url}/distanceMatrix`, options);
      if (!response.ok) {
        const error = new Error('HTTP error');
        error.response = response;
        throw error;
      }

      const scheduleViability = await response.json();

      return scheduleViability

    } catch (error) {
      return returnObject(error.response.status, error.response.statusText);
    }
  };

  const groupPatients = async (userId, accessToken, clusters) => {
    try {
      const options = {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}`},
        body: JSON.stringify({clusters: clusters})
      }
      const response = await fetch(`${url}/group_patients/${userId}`, options);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const groupData = await response.json();

      return groupData;
         
    } catch (error) {
      console.error('Error:', error);

      const errorResponse = {
        error: 'An error occurred while creating user data',
        message: error.message 
      };

      return errorResponse;
    }
  };

  const manuallyGroupPatients = async (userId, accessToken, patients) => {
    try {
      const options = {
        method: 'PUT',
        headers: {'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}`},
        body: JSON.stringify({patients: patients})
      }
      const response = await fetch(`${url}/manually_group_patients/${userId}`, options);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const patientsData = await response.json();

      return patientsData;
         
    } catch (error) {
      console.error('Error:', error);

      const errorResponse = {
        error: 'An error occurred while creating user data',
        message: error.message 
      };

      return errorResponse;
    }
  };

  const saveAutoGroups = async (userId, accessToken, groups) => {
    try {
      const options = {
        method: 'PUT',
        headers: {'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}`},
        body: JSON.stringify(groups)
      }
      const response = await fetch(`${url}/grouping/auto/${userId}`, options);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const groupData = await response.json();
         
    } catch (error) {
      console.error('Error:', error);

      const errorResponse = {
        error: 'An error occurred while creating user data',
        message: error.message 
      };

      return errorResponse;
    }
  };

  const checkGroups = async (userId, accessToken) => {
    try {
      const options = {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}`},
      };

      const response = await fetch(`${url}/checkGroups/${userId}`, options);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      };

      const groupData = await response.json();

      return groupData;

    } catch (error) {
      console.error('Error:', error);

      const errorResponse = {
        error: 'An error occurred while fetching user data',
        message: error.message 
      };

      return errorResponse;
    }
  };

  const saveGroupSet = async (userId, accessToken, groupSet) => {
    try {
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(groupSet)
      };

      const response = await fetch(`${url}/grouping/saveGroupSet/${userId}`, options);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const groupSetOk = await response.json();

      return groupSetOk;

    } catch (error) {
      console.log(error);
      return errorResponse;
    }
  };

  const retrieveGroupSet = async (userId, accessToken, setId) => {
    try {
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify({setId: setId})
      };

      const response = await fetch(`${url}/grouping/retrieveGroupSet/${userId}`, options);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const groupSet = await response.json();

      return groupSet;

    } catch (error) {
      console.log(error);
      return errorResponse;
    }
  };

  return {
    getTimeDistances,
    groupPatients,
    manuallyGroupPatients,
    saveAutoGroups,
    checkGroups,
    saveGroupSet,
    retrieveGroupSet,
  }
}

export default useDistanceRequests;